export default "__VITE_ASSET__CAZt587T__"